import React from 'react';
import * as S from './styles';

type Props = {
  children: React.ReactNode;
};

/**
 * サイドバーとメインコンテンツをレイアウトするためのコンポーネント
 *
 * @param children メインコンテンツ
 * @param sidebar サイドバーコンポーネント
 */
export function ContentsLayout({ children }: Props): React.JSX.Element {
  return <S.Main>{children}</S.Main>;
}
